import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

/** Staff portal: GET /staff-portal/roles */
export const getAllRolesPortal = async () => {
  const res = await axiosInstance.get("/staff-portal/roles");
  return res.data;
};
